import { useEventbriteUrl } from '@/common/constants/useEventbriteUrl';
import { ChevronLeftIcon } from '@eventbrite/marmalade';
import Link from 'next/link';
import styles from './TopNav.module.scss';

interface TopNavProps {
  nav_url: string;
  handleBackNavigation: () => void;
}

export const TopNav: React.FunctionComponent<TopNavProps> = ({ nav_url, handleBackNavigation }) => {
  const HELP_CENTER_YOUR_TICKETS = useEventbriteUrl('HELP_CENTER_YOUR_TICKETS');
  const isHelpCenter = nav_url === 'help-center';
  const nav_href = isHelpCenter ? HELP_CENTER_YOUR_TICKETS : nav_url === 'back' ? '' : nav_url;
  const target = isHelpCenter ? '_blank' : '';
  const nav_text = isHelpCenter ? 'Help Center' : 'Back';

  const handleClick = (e: React.MouseEvent) => {
    if (nav_url === 'back') {
      e.preventDefault();
      handleBackNavigation();
    }
  };

  return (
    <div className={styles.top_nav} onClick={handleClick}>
      <ChevronLeftIcon color="#3659E3" size="small" />
      <Link href={nav_href} target={target} onClick={handleClick}>
        {nav_text}
      </Link>
    </div>
  );
};
